import { ConnectButton } from '@rainbow-me/rainbowkit';

const UserNoWallet = () => {
  return (
    <>
      <section className="flex flex-col items-center justify-center py-6">
        <ConnectButton />
      </section>
    </>
  );
};

export default UserNoWallet;
